/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Simplified/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import InlineNoteEditor from 'DesignSystem/InlineNoteEditor/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Simplified({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication/EmailTemplateEditor/Content/Editor/Simplified",
  onChange
  
}) {
let eventActionDataEmailTemplateContentValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.email_template.content',
})
let eventActionDataEmailTemplateContentChangeData = fromData.useDataChange({ viewPath,
context: 'event_action',
path: 'data.email_template.content',
})
let constantData = 'email-template-'
let eventActionIdValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'id',
})
let aggregateData = fromAggregate.joinNoSpace(constantData, eventActionIdValueData)
let tokensValueData = fromData.useDataValue({ viewPath,
context: 'tokens',
})
  return (<React.Fragment
>
<InlineNoteEditor
  viewPath={`${viewPath}/InlineNoteEditor`}
 data="event_action.data.email_template.content"
 value={eventActionDataEmailTemplateContentValueData}
 onChange={eventActionDataEmailTemplateContentChangeData}
 data="'email-template-'"
 data="event_action.id"
 aggregate="/Data/aggregate.js joinNoSpace"
 containerId={aggregateData}
 marginTop={0}
 marginBottom={0}
 parentHeight={200}
 width="100%"
 toolbarPersist={true}
 toolbar="simplified"
 data="tokens"
 tokens={tokensValueData}
/>
{children}
</React.Fragment>)
}